/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RatioUnit = {
    DecimalFraction: 'RatioUnit.DecimalFraction',
    PartPerBillion: 'RatioUnit.PartPerBillion',
    PartPerMillion: 'RatioUnit.PartPerMillion',
    PartPerThousand: 'RatioUnit.PartPerThousand',
    PartPerTrillion: 'RatioUnit.PartPerTrillion',
    Percent: 'RatioUnit.Percent'
} as const;
export type RatioUnit = typeof RatioUnit[keyof typeof RatioUnit];


export function RatioUnitFromJSON(json: any): RatioUnit {
    return RatioUnitFromJSONTyped(json, false);
}

export function RatioUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): RatioUnit {
    return json as RatioUnit;
}

export function RatioUnitToJSON(value?: RatioUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RatioUnit interface.
 */
 export function instanceOfRatioUnit(value: any): value is RatioUnit {
    return Object.values(RatioUnit).includes(value)
}

